module.exports = {
  CARD_ISSUE_QUEUE_STATUS: {
    NEW: 'NEW',
    ISSUED: 'ISSUED'
  },
  CARD_DELIVERY_TYPE: {
    NORMAL_LOCAL: 'NORMAL_LOCAL',
    EXPRESS_LOCAL: 'EXPRESS_LOCAL',
    INTERNATIONAL: 'INTERNATIONAL'
  }
};
